

module.exports = __webpack_require__.stylable.create(
    "OfferingView2314191375",
    {"classes":{"root":"OfferingView2314191375__root","OverlappingMediaContainer":"OverlappingCard255404364__mediaContainer","ClassicCardMediaContainer":"Card1864624388__mediaContainer","StripCardMediaContainer":"StripCard1925337307__mediaContainer","overlapping":"OfferingView2314191375__overlapping","OverlappingCardInfoContainer":"OverlappingCard255404364__infoContainer","classic":"OfferingView2314191375__classic","ClassicCardInfoContainer":"Card1864624388__infoContainer","strip":"OfferingView2314191375__strip","grid":"OfferingView2314191375__grid","ClassicCardDeprecated":"Card1864624388__deprecated"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    4,
    "OfferingView2314191375",
    null
);
